import { NavLink, useLocation } from "react-router-dom";
import Points from "../img/points.svg?react";
import Dropdown from "../img/dropdown.svg?react";
import Coupon from "../img/cupon.svg?react";
import Support from "../img/support.svg?react";
import Info from "../img/info.svg?react";
import Glo from "../img/glo.svg?react";
import GloW from "../img/gloW.svg?react";
import Vuse from "../img/vuse.svg?react";
import Brithday from "../img/brithday.svg?react";
import Send from "../img/send.svg?react";
import "./style.scss";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getIdentify,
  getToken,
  REDIRECT_CACHE_TIME,
  REDIRECT_STALE_TIME,
} from "../../../api/redirect";
import { useEffect, useState } from "react";
import { canAccessQrScanner } from "../../../Helpers";
import Insider from "../img/insider.svg?react";
import QrScanner from "../img/qr-scanner.svg?react";
import SubIcon from "../img/sub-icon.svg?react";
import DOMPurify from "dompurify";

const navItems = [
  // {
  //   name: "Geburtstagsfreude",
  //   icon: <Brithday />,
  //   link: "/inspirationClubBrithdayPage",
  //   cls: "brithday-icon",
  // },
  {
    name: "Mein PremiumAbo",
    icon: <SubIcon />,
    link: "/subscription",
    cls: "ultra-icon",
  },
  {
    name: "Ultra Space",
    icon: <Vuse />,
    link: "/ultra-insider",
    cls: "ultra-icon",
  },
  {
    name: "Punkte sammeln",
    icon: <Points />,
    link: "/activities",
    cls: "points-icon",
  },
  {
    name: "Punkte eintauschen",
    icon: <Coupon />,
    link: "/coupons",
    cls: "coupons-icon",
  },
  {
    name: "Vuse Umfrage",
    icon: <QrScanner />,
    link: "/qr-scanner-landing",
    cls: "qr-scanner-icon",
  },
  {
    name: "Freunde einladen",
    icon: <Send />,
    link: "/invite",
    cls: "recomend-icon",
  },
  {
    name: "Kontakt",
    icon: <Support />,
    link: "/contact",
    cls: "contact-icon",
  },
  {
    name: "Über das Programm",
    icon: <Info />,
    link: "/about",
    cls: "about-icon",
  },
];

const ecommConfig = {
  discoverglode: `${import.meta.env.VITE_DG_URL}/`,
  vusede: `${import.meta.env.VITE_VUSE_URL}`,
};

const tokenBasedConfig = {
  discoverglode: `${
    import.meta.env.VITE_DG_URL
  }/inspiration_club/customer/login?redirect=${btoa(
    import.meta.env.VITE_DG_URL,
  )}&ic_member_token=`,
  vusede: `${
    import.meta.env.VITE_VUSE_URL
  }/inspiration_club/customer/login?redirect=${btoa(
    import.meta.env.VITE_VUSE_URL,
  )}&ic_member_token=`,
};

export default function NavList({
  closeNav,
  handleOpenList,
  activeLink,
  brands,
}) {
  const queryClient = useQueryClient();
  const [identifyTouchpiont, setIdentifyTouchpiont] = useState(null);
  const location = useLocation();
  const isUltraInsider =
    location.pathname.includes("/subscription") ||
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const isQrScanner =
    location.pathname.startsWith("/qr-scanner") ||
    location.pathname.startsWith("/qr-register");

  const visibleNavItems = canAccessQrScanner(brands)
    ? navItems
    : navItems.filter((item) => item.link !== "/qr-scanner-landing");

  // 🔁 ZAMIANA: skinOn -> activeSkin
  const [activeSkin, setActiveSkin] = useState(
    localStorage.getItem("activeSkin") || null,
  );

  const { data: identifyData, isSuccess: identifySuccess } = useQuery({
    queryKey: ["consumer-redirect-identify"],
    queryFn: getIdentify,
    staleTime: REDIRECT_STALE_TIME,
    cacheTime: REDIRECT_CACHE_TIME,
  });

  useEffect(() => {
    if (identifyData && !localStorage.getItem("identify")) {
      localStorage.setItem("identify", identifyData.token.touchpoint);
      setIdentifyTouchpiont(identifyData.token.touchpoint);
      dataLayer.push({
        event: "login_source",
        touchpoint: identifyData.token.touchpoint,
      });
    }
  }, [identifyData]);

  const handleEcommLinkClick = async (touchpoint) => {
    if (identifyTouchpiont === touchpoint) {
      const url = ecommConfig[touchpoint];
      if (url) {
        window.location.href = url;
      }
    } else if (identifySuccess) {
      const data = await queryClient.fetchQuery({
        queryKey: ["consumer-redirect-token"],
        queryFn: () => getToken(touchpoint),
        staleTime: REDIRECT_STALE_TIME,
        cacheTime: REDIRECT_CACHE_TIME,
      });

      if (data) {
        const url = tokenBasedConfig[touchpoint];
        if (url) {
          window.location.href = `${url}${data.token}`;
        }
      }
    }
  };

  useEffect(() => {
    const updateSkin = () => {
      setActiveSkin(localStorage.getItem("activeSkin") || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => {
      window.removeEventListener("skinChange", updateSkin);
    };
  }, []);

  return (
    <ul className="navigation-list">
      {visibleNavItems.map((item) => (
        <li key={item.link} className="list-item">
          {item.subnav ? (
            <NavLink
              onClick={(e) => {
                handleOpenList(item.name);
                if (item.subnav) {
                  e.preventDefault();
                }
              }}
              to={item.link}
              className={activeLink === item.name ? "item active" : "item"}
            >
              <span className={`icon ${item.cls ? item.cls : ""}`}>
                {item.icon}
              </span>
              <span className="name">{item.name}</span>

              <span className="dropdown-icon">
                <Dropdown />
              </span>
            </NavLink>
          ) : (
            <NavLink
              onClick={() => {
                handleOpenList(false);
                if (item.name === "Eiersuche") {
                  dataLayer.push({
                    event: "easter_page",
                    source: "navigation",
                  });
                }
                closeNav();
              }}
              to={item.link}
              className="item"
            >
              <span className={`icon ${item.cls ? item.cls : ""}`}>
                {item.icon}
              </span>
              <span
                className="name"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.name),
                }}
              />
            </NavLink>
          )}
        </li>
      ))}
      <li className="ecomm-links-wrapper">
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleEcommLinkClick("discoverglode")}
          className="ecomm-links"
        >
          {isUltraInsider || isQrScanner ? (
            <GloW />
          ) : activeSkin ? (
            <GloW />
          ) : (
            <Glo />
          )}
          <span className="name"> myglo.com</span>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleEcommLinkClick("vusede")}
          className="ecomm-links vuse"
        >
          <Vuse />
          <span className="name">vuse.com</span>
        </a>
      </li>
    </ul>
  );
}
